import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts'

interface DailyCost {
  date: string
  total: number
  anthropic: number
  voyage: number
}

interface CostChartProps {
  data: DailyCost[]
}

// Only tracked costs (real data, not hardcoded tier estimates). Supabase/
// Vercel/Railway were removed in s45 — their collectors were pure
// fallbacks to fixed monthly pricing ($25+$20+$20) that never varied
// with actual usage, so they added noise without signal.
const COLORS = {
  anthropic: '#7c3aed',
  voyage: '#0891b2',
}

export function CostChart({ data }: CostChartProps) {
  const formatted = data.map((d) => ({
    ...d,
    date: d.date.slice(5), // MM-DD
  }))

  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.8)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '20px',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--serif)',
          fontSize: '18px',
          fontWeight: 600,
          color: 'var(--ink)',
          marginBottom: '16px',
        }}
      >
        Custos Diarios (30 dias)
      </div>
      <ResponsiveContainer width="100%" height={320}>
        <BarChart data={formatted} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: 'var(--ink-muted)' }}
            interval={Math.max(0, Math.floor(formatted.length / 8) - 1)}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--ink-muted)' }}
            tickFormatter={(v) => `$${v}`}
          />
          <Tooltip
            formatter={(value, name) => [`$${Number(value).toFixed(4)}`, String(name)]}
            contentStyle={{
              background: 'var(--cream)',
              border: '1px solid var(--border)',
              borderRadius: '8px',
              fontFamily: 'var(--sans)',
              fontSize: '12px',
            }}
          />
          <Legend
            wrapperStyle={{ fontFamily: 'var(--sans)', fontSize: '12px' }}
          />
          <Bar dataKey="anthropic" stackId="a" fill={COLORS.anthropic} name="Anthropic" />
          <Bar dataKey="voyage" stackId="a" fill={COLORS.voyage} name="Voyage AI" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
